import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { removeSpecialCharacters } from '@/common/utils/unFormatters'
import { ContractEnvelopeWitnessValidationSchema } from '@/features/privateCompanyLeadsFunnel/schemas/contractEnvelope.schema'
import { useMutation } from '@tanstack/react-query'

interface UseAddContractEnvelopeWitnessProps {
  id?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useAddContractEnvelopeWitness = ({ id, onSuccess, onError }: UseAddContractEnvelopeWitnessProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['addContractEnvelopeWitness'],
    mutationFn: async (form: ContractEnvelopeWitnessValidationSchema) => {
      const private_company_lead = {
        contract_attributes: {
          valid_envelope_attributes: {
            witnesses_attributes: [
              {
                ...form.contract.valid_envelope.witnesses,
                cpf: removeSpecialCharacters(form.contract.valid_envelope.witnesses.cpf),
              },
            ],
          },
        },
      }

      await privateAxios.put(`/funnel/private_company_leads/${id}`, {
        private_company_lead,
      })
    },
    onSuccess,
    onError,
  })
}
